import React, { useState } from 'react'
import {
  ConfirmModal,
  Activity
} from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import { gql, useApolloClient } from '@apollo/client'

const SetPendingMultipleLessons = (props) => {
  const { refetchCalendarQuery, setLessonsSelected } = props
  const { isOpen, lessonsId } = useSelector((state) => state.modal.lesson.setPendingMultiple)
  const { translate } = useTranslation()
  const dispatch = useDispatch()
  const client = useApolloClient()
  const toggle = () => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'lesson.setPendingMultiple',
      data: {
        isOpen: false,
        lessonsId
      }
    })
  }
  const [loading, setLoading] = useState(false)

  return (
    <ConfirmModal
      className=''
      classNameActionDiv='flex-column'
      classNameConfirm='text-right text-primary'
      classNameCancel='mx-3 text-right'
      isOpen={isOpen}
      backdrop='static'
      toggle={toggle}
      title={translate('lesson.multipleselection.setpending')}
      body={translate('lesson.multipleselection.setpendingbody')}
      confirmAction={() => {
        let mutation = lessonsId.reduce((stringMutation, lesson, index) => {
          return stringMutation + `pending${index}: setLessonToPending (lessonId: "${lesson}"){id}\n`
        }, '')
        mutation = 'mutation {\n' + mutation + '}'
        try {
          setLoading(true)
          client.mutate({
            mutation: gql`${mutation}`,
            update: () => {
              // ejecutar refetch del calendario
              refetchCalendarQuery()
              setLessonsSelected([])
              setLoading(false)
              toggle()
            }
          })
        } catch {
          // error en try
          console.error('Error al ejecutar petición setLessonToPending.')
          setLoading(false)
        }
      }}
      cancelAction={toggle}
      confirmText={loading ? <Activity /> : translate('lesson.multipleselection.okleave')}
      cancelText={translate('lesson.multipleselection.dontdo')}
    />
  )
}

export default SetPendingMultipleLessons
